import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const faqs = [
  {
    question: 'Welche Losgrößen fertigen Sie?',
    answer:
      'Vom Einzelteil bis zur Kleinserie. Ideal sind Stückzahlen von 1 bis 200 Teilen – Prototypen, Ersatzteile und wiederkehrende Kleinserien für Automatisierungstechnik und Sondermaschinenbau.',
  },
  {
    question: 'Wie groß dürfen die Bauteile sein?',
    answer:
      'In der 3-Achs-Bearbeitung fertigen wir Teile bis 610 x 420 mm, in der 5-Achs-Bearbeitung bis 350 x 180 mm. Bei Grenzfällen prüfen wir die Machbarkeit direkt anhand Ihrer Zeichnung.',
  },
  {
    question: 'Welche Toleranzen sind möglich?',
    answer:
      'Passungen bis H7 fertigen wir standardmäßig. Engere Vorgaben besprechen wir vorab, damit Aufwand und Kosten für Sie kalkulierbar bleiben.',
  },
  {
    question: 'Welche Werkstoffe bearbeiten Sie?',
    answer:
      'Aluminium, Stahl, Edelstahl, Messing sowie technische Kunststoffe. Auch Sonderwerkstoffe sind nach Absprache möglich.',
  },
  {
    question: 'Welche Dateiformate benötigen Sie für eine Anfrage?',
    answer:
      'Wir verarbeiten STEP (.step, .stp), IGES (.iges, .igs), SolidWorks (.sldprt), DXF und DWG. Auch bemaßte PDF-Zeichnungen sind für eine erste Einschätzung ausreichend.',
  },
  {
    question: 'Wie schnell bekomme ich eine Rückmeldung?',
    answer:
      'Über die FastLane-Anfrage meldet sich ein Mitarbeiter innerhalb von Minuten, bei einer Standardanfrage innerhalb weniger Stunden. Die Machbarkeitsprüfung erfolgt in der Regel am selben Tag.',
  },
  {
    question: 'Wie kann ich Kosten sparen?',
    answer:
      'Über die kostenoptimierte Produktion nutzen wir freie Kapazitäten in unserer Planung. Wenn Ihr Termin flexibel ist, sind dadurch bis zu 40% Ersparnis gegenüber einer Expressfertigung möglich.',
  },
  {
    question: 'Übernehmen Sie auch Oberflächenbehandlungen?',
    answer:
      'Ja, über ausgewählte Partner in der Region: Eloxieren, Hartcoatieren, Verzinken, Vernickeln, Brünieren, Nitrieren, Verchromen und Lackieren. Die Teile bringen und holen wir persönlich – ohne unnötigen Paketversand.',
  },
  {
    question: 'Wo sitzen Sie und liefern Sie überregional?',
    answer:
      'Unser Betrieb liegt in Stamsried in der Oberpfalz, im Landkreis Cham zwischen Regensburg und der tschechischen Grenze. Geliefert wird deutschlandweit über Ihren Wunschversand.',
  },
];

const FaqSection = () => {
  return (
    <section id="faq" className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            Häufige Fragen
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Antworten zu Losgrößen, Toleranzen, Werkstoffen und Ablauf
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={faq.question} value={`faq-${index}`}>
                <AccordionTrigger className="text-left font-heading font-bold text-base md:text-lg text-foreground">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;